export default "__VITE_PUBLIC_ASSET__b3782f59__"